import { AUTHENTICATION } from "./authenticationConstants.js";

// -- AUTHENTICATION -- //

// email (domain) -> link -> redirect
export const doLoginFederatedLink = email => {
  return {
    type: AUTHENTICATION.LOGIN_FEDERATED_LINK.DO,
    payload: { email }
  };
};

// callback (code) -> jwt
export const exchangeFederatedCode = payload => ({
  type: AUTHENTICATION.LOGIN_FEDERATED_EXCHANGE.DO,
  payload
});
